export default __webpack_public_path__ + "static/media/background_mssh.e9cec2d7.jpg";